<template>
  <div class="steps-bd">
    <div class="step ub ub-xc">
      <template v-for="(item, idx) in list">
        <div class="ub-f1" :class="{ bar: idx != 0, cur: idx <= currentIndex }" :key="`0-${idx}`"></div>
        <div :class="{ cur: idx <= currentIndex }" class="dit" :key="`1-${idx}`" @click="changeStep(item)">{{ item.label }}</div>
        <div class="ub-f1" :class="{ bar: idx != list.length - 1, cur: idx < currentIndex }" :key="`2-${idx}`"></div>
      </template>
    </div>
    <div class="info ub">
      <div class="ub-f1" v-for="(value, index) in list" :key="index">
        <h1>{{ value.title }}</h1>
        <p v-if="value.subTitle">
          {{ value.subTitle }}
          <span v-if="value.subNum">{{ value.subNum }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    list: {
      type: Array,
      default() {
        return [
          {
            label: '',
            value: '',
            title: '',
            subTitle: '',
            subNum: ''
          }
        ];
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    currentIndex: vm => vm.list.findIndex(t => t.value === vm.value) || 0
  },
  methods: {
    // 变更
    changeStep: function (item) {
      this.$emit('change', item);
    }
  }
};
</script>
<style lang="scss">
@import '@/style/colors.scss';

.steps-bd {
  .step {
    .dit {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin: 0 8px;
      line-height: 24px;
      text-align: center;
      color: #ffffff;
      border-radius: 50%;
      background-color: #b3b3b3;
      font-size: 14px;
      &.cur {
        background-color: $--color-primary;
      }
    }
    .bar {
      height: 1px;
      background-color: #b3b3b3;
      &.cur {
        background-color: $--color-primary;
      }
    }
  }
  .info {
    margin-top: 10px;
    h1 {
      font-size: 14px;
      color: $--color-text-secondary;
      line-height: 21px;
      font-weight: bold;
      text-align: center;
    }
    p {
      text-align: center;
      color: #818181;
      font-size: 14px;
      line-height: 21px;
      span {
        color: $--color-primary;
      }
    }
  }
}
</style>
